/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Entra_Docs_LinkInputs */



/**
* | output |
* | --- |
* | "Microsoft Entra ID Documentation" |
*
* @param {Scim_Setup_Entra_Docs_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_entra_docs_link = /** @type {((inputs?: Scim_Setup_Entra_Docs_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Entra_Docs_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Microsoft Entra ID Dokumentation")
	return /** @type {LocalizedString} */ ("Microsoft Entra ID Documentation")
});